var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"OfflineTime"},[_vm._v("\n  ("),_c('CountDown',{staticStyle:{"position":"relative","top":"1px"},attrs:{"time":_vm.milliseconds},on:{"finish":function($event){_vm.$emit('ok')}}}),_vm._v("后截止)\n")],1)}
var staticRenderFns = []

export { render, staticRenderFns }